<template>
  <div>
    <div v-for="(ticket, index) in tickets" :key="index" class='full-page'>
      <div class='contemplado'>
        <img class='selo' src='../assets/img/selo.png'>
        <div id='img' class='img'>
          <!-- Imagem do contemplado -->
          <!-- <img :src="`${db.host}/${db.name}/${ticket.customer._id}/image.jpg`"> -->
        </div>
        <div class='name'>{{ obfuscateString(ticket.customer.holder) }} </div>
        <div class='info'>
          <div> UC: {{ ticket.customer.uc }} </div> <br>
          <!-- <div> CPF: {{ ticket.customer.cpf }} </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'winner-slides',

  props: ['tickets'],

  computed: {
    db () {
      return {
        host: process.env.DB_HOST,
        name: process.env.DB_NAME
      }
    }
  },
  methods: {
    obfuscateString (str) {
      if (typeof str === 'string') {
        const strObfuscado = str.substring(0, 3) + '***********' + str.substring(str.length - 3, str.length)

        return strObfuscado
      }

      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WinnerSlides.vue